'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesController', ['$scope', 'commonUtil', 'Global', 'MeanUser',
    'userService', 'builderService', 'ngDialog', 'toaster', '$stateParams',
    '$filter', 'contactService', 'Trades', 'Builders', 'Projects',
    'ProjectHours', 'aceUtils', 'Users', 'Materials', 'taskListService', 'tradeCodeService', 'Equipments', '$q',
    function ($scope, commonUtil, Global, MeanUser, userService, builderService, ngDialog, toaster, $stateParams, $filter, contactService, Trades, Builders, Projects, ProjectHours, aceUtils, Users, Materials, taskListService, tradeCodeService, Equipments, $q) {
        $scope.global = Global;
        $scope.package = {
            name: 'contacts'
        };
        $scope.user = MeanUser.user;
        $scope.get_results = false;

        $scope.menu = ['Labor', 'Clock Hours', 'Time Cards', 'Inventory', 'Material Invoices', 'Material List', 'Equipment Invoices', 'Equipment List', 'Tasks', 'Extras'];
        $scope.current_menu = 'Labor';
        $scope.selectedIndex = 0;

        $scope.projects = [];
        $scope.all_projects = [];
        $scope.employees = [];
        $scope.suppliers = [];
        $scope.suppliers = [];
        $scope.inventorySuppliers = [];
        $scope.inventoryCategories = [];
        $scope.equipment_suppliers = [];
        $scope.payperiods = [];
        $scope.scheduledOn = false;
        $scope.completedOn = false;
        $scope.materialDate = false;
        $scope.showOnlyLeft = false;
        $scope.users_trade_account = {};
        $scope.database_view = true;
        $scope.selectedDateSearchType = 'invoice';

        $scope.selectedTaskStatus = {
            name: 'All'
        };

        $scope.selectedExtrasStatus = {
            name: 'All'
        };

        $scope.task_status = [{
            'name': 'All'
        }, {
            'name': 'finished'
        }, {
            'name': 'work_stoppage'
        }, {
            'name': 'on_track'
        }, {
            'name': 'delayed_start'
        }];

        $scope.extras_status = [{
            'name': 'All'
        }, {
            'name': 'Open'
        }, {
            'name': 'Billed'
        }, {
            'name': 'Paid'
        }];

        $scope.is_builder = builderService.isBuilder($scope.user.username);

        taskListService.getByTrade(tradeCodeService.getCode(
            $scope.user.trade[0])).then(function (result) {
                $scope.trade_tasks = $filter('orderBy')(result, 'task_code');

                $scope.trade_tasks.unshift({
                    task_code: 'All'
                });
            });

        $scope.getBuilderList = function (builders) {
            var deferred = $q.defer();
            var returned_items = [];

            _.each(builders, function (builder) {
                Builders.query({ 'builder': builder._id }, function (builders) {
                    var builder = builders[0];
                    builder.company_code = aceUtils.padDigits(builder.company_code, 3);
                    builder.trade_code = builder.trade_code ? builder.trade_code :
                        tradeCodeService.getCode(builder.trade)
                    returned_items.push(builder);
                });
            });

            $q.all(returned_items).then(function (results) {
                deferred.resolve(results);
            });

            return deferred.promise;
        };

        userService.getMainAccount($scope.user.username).then(function (main_account) {
            $scope.main_account = main_account;
            contactService.getMyContacts($scope.main_account._id).then(function (contacts) {
                $scope.builders = [];
                $scope.builders.unshift({
                    name: 'All'
                });
                console.log('getting contacts');

                Trades.query({ 'main_account_id': $scope.main_account._id }, function (trade) {
                    $scope.users_trade_account = trade[0];

                    trade[0].company_code =
                        aceUtils.padDigits(trade[0].company_code, 3);
                    trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                    $scope.builders.push(trade[0]);

                    Projects.query({
                        'complete': false,
                        'company_code': trade[0].company_code,
                        'trade_code': trade[0].trade_code
                    }, function (projects) {

                        projects.forEach(function (project) {
                            $scope.all_projects.push(project);
                        });
                    });

                    $scope.setPayPeriods();

                    Materials.query({
                        'trade_account': trade[0]._id,
                        'get_suppliers': 1,
                        'userId': $scope.main_account._id
                    }, function (items) {
                        items.forEach(function (item) {
                            $scope.suppliers.push({
                                name: item,
                                isInventory: item.isInventory,
                                category: item.category
                            });
                        });

                        $scope.suppliers.unshift({
                            name: 'All'
                        });
                    });

                    Materials.query({
                        'trade_account': trade[0]._id,
                        'get_suppliers': true,
                        'isInventory': true,
                        'userId': $scope.main_account._id
                    }, function (items) {
                        for (const element of items) {
                            $scope.inventorySuppliers.push({ name: element });
                        }
                        $scope.inventorySuppliers.unshift({ name: 'All' });
                        console.log($scope.inventorySuppliers)
                    });
                    Materials.query({
                        'trade_account': trade[0]._id,
                        'get_category': true,
                        'isInventory': true,
                        'userId': $scope.main_account._id
                    }, function (items) {
                        for (const element of items) {
                            $scope.inventoryCategories.push({ name: element });
                        }

                        $scope.inventoryCategories.unshift({ name: 'All' });
                    });

                    Equipments.query({
                        'trade_account': trade[0]._id,
                        'get_suppliers': 1
                    }, function (items) {
                        items.forEach(function (item) {
                            $scope.equipment_suppliers.push({
                                name: item
                            });
                        });

                        $scope.equipment_suppliers.unshift({
                            name: 'All'
                        });
                    });

                    contacts.builders.forEach(function (builder) {
                        Builders.query({ 'builder': builder._id }, function (builders) {
                            if (builders.length === 0) return;
                            builders[0].company_code =
                                aceUtils.padDigits(builders[0].company_code, 3);
                            builders[0].trade_code = '00';
                            $scope.builders.push(builders[0]);
                            Projects.query({
                                'complete': false,
                                'company_code': builders[0].company_code,
                                'trade_code': builders[0].trade_code,
                                'match_string': true,
                                'username': $scope.main_account.username
                            }, function (projects) {

                                projects.forEach(function (project) {
                                    $scope.all_projects.push(project);
                                });
                            });
                        });
                    });
                });
            });
        });

        Users.query({
            'trade': $scope.user.trade[0],
            //'active': true,
            'contractor_code': $scope.user.contractor_code
        }, function (users) {
            users.forEach(function (user) {
                if (user.roles[0] === 'tm_admin') {
                    user.role = 'Admin'; //not used yet but might be in future
                } else if (user.roles[0] === 'tm_office') {
                    user.role = 'Office'; //not used yet but might be in future
                } else if (user.roles[0] === 'tm') {
                    user.role = 'Manager'; //not used yet but might be in future
                } else if (user.roles[0] === 'foreman') {
                    user.role = 'Foreman';
                    $scope.employees.push(user);
                } else {
                    user.role = 'Tradesman';
                    $scope.employees.push(user);
                }
            });
        });

        $scope.$on('materialNamesLoadEvent', function (event, data) {
            $scope.material_names = $filter('orderBy')(data.names, 'name');

            $scope.material_names.unshift({
                name: 'All'
            });

            $scope.selectedMaterialName = $scope.material_names[0];
        });

        // $scope.filterMaterialName = function(item) {
        //     if($scope.selectedMaterialName.name === 'All') return item;

        //     if($scope.material_names.indexOf($scope.selectedMaterialName) !== -1) return item;
        // };

        $scope.init = function () {
            $scope.getResults();
        };

        $scope.onSelect = function (item, indexNo) {
            if (!$scope.get_results) return;
            $scope.current_menu = item;
            $scope.selectedIndex = indexNo;
            ($scope.current_menu === 'Inventory') && $scope.$broadcast('resetInvetoryTab', {
                selectedTab: 'InvoiceTab',
                buttonLabel: 'Inventory Setup'
            });
        };

        $scope.submit = function (item) {
            if (aceUtils.isUndefinedOrNull($scope.selectedBuilder) ||
                aceUtils.isUndefinedOrNull($scope.selectedItem)) {
                $scope.selectedPhase = {
                    name: 'All'
                }

                $scope.selectedLot = {
                    name: 'All'
                }
            }

            if (aceUtils.isUndefinedOrNull($scope.selectedSupplier))
                $scope.selectedSupplier = {
                    name: 'All'
                }
            if (aceUtils.isUndefinedOrNull($scope.selectedCategory))
                $scope.selectedCategory = {
                    name: 'All'
                }

            if (aceUtils.isUndefinedOrNull($scope.selectedBuilder))
                $scope.selectedBuilder = {
                    name: 'All'
                }

            if (aceUtils.isUndefinedOrNull($scope.selectedItem))
                $scope.selectedItem = {
                    name: 'All'
                }

            if (aceUtils.isUndefinedOrNull($scope.selectedEmployee))
                $scope.selectedEmployee = {
                    username: 'All'
                }

            if (aceUtils.isUndefinedOrNull($scope.selectedMaterialName))
                $scope.selectedMaterialName = {
                    name: 'All'
                }

            if (aceUtils.isUndefinedOrNull($scope.selectedLot))
                $scope.selectedLot = {
                    task_code: 'All'
                }

            if (aceUtils.isUndefinedOrNull($scope.selectedTask))
                $scope.selectedTask = {
                    task_code: 'All'
                }

            var searchProperties = {};

            if ($scope.current_menu === 'Extras') {
                searchProperties = {
                    status: $scope.selectedExtrasStatus.name,
                    builder: $scope.selectedBuilder,
                    project_id: $scope.selectedItem._id,
                    phase: $scope.selectedPhase.name,
                    lot: $scope.selectedLot.name,
                    task: $scope.selectedTask.task_code
                }
            } else {
                searchProperties = {
                    status: $scope.selectedTaskStatus.name,
                    supplier: $scope.selectedSupplier.name,
                    category: $scope.selectedCategory.name,
                    employee: $scope.selectedEmployee.username,
                    material_name: $scope.selectedMaterialName.name,
                    builder: $scope.selectedBuilder,
                    project_id: $scope.selectedItem._id,
                    phase: $scope.selectedPhase.name,
                    lot: $scope.selectedLot.name,
                    task: $scope.selectedTask.task_code,
                    date_type: $scope.selectedDateSearchType,
                    start: $scope.startDate,
                    end: $scope.endDate
                }
            }

            if ($scope.current_menu === 'Labor') {
                $scope.$broadcast('laborLoadEvent', {
                    searchProp: searchProperties
                });
            } else if ($scope.current_menu === 'Clock Hours') {
                $scope.$broadcast('hoursLoadEvent', {
                    searchProp: searchProperties
                });
            } else if ($scope.current_menu === 'Time Cards') {
                $scope.$broadcast('timesLoadEvent', {
                    searchProp: searchProperties
                });
            } else if ($scope.current_menu === 'Material Invoices') {
                $scope.materialInvoiceBroadcast = {
                    searchProp: searchProperties,
                    materialDate: $scope.materialDate
                };
                $scope.$broadcast('materialInvoicesLoadEvent', {
                    searchProp: searchProperties,
                    materialDate: $scope.materialDate
                });
            } else if ($scope.current_menu === 'Inventory') {
                $scope.materialDate = true;
                searchProperties.userId = $scope.main_account._id
                $scope.$broadcast('materialInventoryLoadEvent', {
                    searchProp: searchProperties,
                    showOnlyLeft: $scope.showOnlyLeft,
                    materialDate: $scope.materialDate
                });
            } else if ($scope.current_menu === 'Material List') {
                $scope.$broadcast('materialListLoadEvent', {
                    searchProp: searchProperties
                });
            } else if ($scope.current_menu === 'Equipment Invoices') {
                $scope.$broadcast('equipmentInvoicesLoadEvent', {
                    searchProp: searchProperties,
                    materialDate: $scope.materialDate
                });
            } else if ($scope.current_menu === 'Equipment List') {
                $scope.$broadcast('equipmentListLoadEvent', {
                    searchProp: searchProperties
                });
            } else if ($scope.current_menu === 'Tasks') {
                $scope.$broadcast('tasksLoadEvent', {
                    searchProp: searchProperties,
                    scheduledStart: $scope.scheduledStartDate,
                    scheduledEnd: $scope.scheduledEndDate,
                    completedStart: $scope.completedStartDate,
                    completedEnd: $scope.completedEndDate,
                    scheduledEnabled: $scope.scheduledOn,
                    completedEnabled: $scope.completedOn
                });
            } else if ($scope.current_menu === 'Extras') {
                $scope.$broadcast('extrasLoadEvent', {
                    searchProp: searchProperties
                });
            }
        };

        var strFormat = 'DD MMM YYYY';

        $scope.incrementPayPeriod = function (period) {
            if (period === 'weekly') {
                $scope.payEndDate.add(7, 'days');
            } else if (period === 'biweekly') {
                $scope.payEndDate.add(14, 'days');
            }

            var startDate;

            if (period === 'weekly') {
                startDate = moment($scope.payEndDate).subtract(6, 'days');
            } else if (period === 'biweekly') {
                startDate = moment($scope.payEndDate).subtract(13, 'days');
            }

            $scope.payperiods.push({
                start: moment(startDate),
                end: moment($scope.payEndDate),
                string: startDate.format(strFormat) + ' - ' + $scope.payEndDate.format(strFormat)
            });

            if ($scope.payStartDate <= $scope.payToday && $scope.payToday <= $scope.payEndDate) {
                $scope.payStartDate = moment(startDate);
                return -1;
            }
            else
                return 0;
        };

        $scope.setPayPeriods = function () {
            var company_code = aceUtils.padDigits($scope.users_trade_account.company_code, 3);
            var trade_code = $scope.users_trade_account.trade_code ?
                $scope.users_trade_account.trade_code :
                tradeCodeService.getCode($scope.users_trade_account.trade)

            if (!$scope.users_trade_account.payroll_end_date || !$scope.users_trade_account.payroll_period) {
                toaster.pop('error', 'No Payroll Settings', 'Please set payroll settings in Company Admin');
                return;
            }

            $scope.payStartDate = moment($scope.users_trade_account.payroll_end_date).add(1, 'day');
            $scope.payEndDate = moment($scope.users_trade_account.payroll_end_date).add(1, 'day');
            if ($scope.users_trade_account.payroll_period === 'weekly') {
                $scope.payEndDate.add(6, 'day');
            } else if ($scope.users_trade_account.payroll_period === 'biweekly') {
                $scope.payEndDate.add(13, 'day');
            }

            $scope.payToday = moment();

            $scope.payperiods = [];

            while ($scope.incrementPayPeriod(
                $scope.users_trade_account.payroll_period) !== -1) {
            }

            $scope.payperiods.reverse();
        };

        $scope.changeBuilder = function () {
            if (!$scope.selectedBuilder) return;
            $scope.projects = [];
            $scope.tasks = [];
            $scope.phases = [];
            $scope.lots = [];
            $scope.bid_tasks = [];
            $scope.trades = [];

            var company_code = aceUtils.padDigits($scope.selectedBuilder.company_code, 3);
            var trade_code = $scope.selectedBuilder.trade_code ?
                $scope.selectedBuilder.trade_code :
                tradeCodeService.getCode($scope.selectedBuilder.trade)

            $scope.projects = $filter('filter')($scope.all_projects, {
                'company_code': company_code,
                'trade_code': trade_code
            }, true);

            $scope.projects = $filter('orderBy')($scope.projects, ['name'], false);

            $scope.projects.unshift({
                name: 'All'
            });

            $scope.selectedItem = $scope.projects[0];
            $scope.changeProject();
            $scope.selectedTask = $scope.trade_tasks[0];
        };

        $scope.changeProject = function () {
            var lots = $filter('unique')($scope.selectedItem.lots, 'phase');

            $scope.phases = [];
            _.each(lots, function(lot) {
                $scope.phases.push({
                    'name': lot.phase
                });
            });

            $scope.phases = $filter('orderBy')($scope.phases, ['name'], false);
            $scope.phases.unshift({
                name: 'All'
            });

            $scope.selectedPhase = $scope.phases[0];
            $scope.changePhase();
        };

        $scope.changePhase = function () {
            if (!$scope.selectedPhase) return;
            if (!$scope.selectedItem || !$scope.selectedItem.lots) return;

            $scope.lots = [];

            if ($scope.selectedPhase.name === 'All') {
                for (var i = 0; i < $scope.selectedItem.lots.length; i++) {
                    $scope.lots.push({
                        'name': $scope.selectedItem.lots[i].number
                    });
                }
            } else {
                //var my_tasks = $filter('filter')($scope.tasks, {'phase': $scope.selectedPhase.name});
                for (var i = 0; i < $scope.selectedItem.lots.length; i++) {
                    if ($scope.selectedItem.lots[i].phase === $scope.selectedPhase.name) {
                        $scope.lots.push({
                            'name': $scope.selectedItem.lots[i].number
                        });
                    }
                }
            }

            $scope.lots = $filter('orderBy')($scope.lots, ['name'], false);

            $scope.lots.unshift({
                name: 'All'
            });

            $scope.selectedLot = $scope.lots[0];
            $scope.selectedTask = $scope.trade_tasks[0];
        };

        $scope.changeLot = function () {
            if (!$scope.selectedLot) return;

            if ($scope.selectedLot.name === 'All') {
                var my_tasks = $scope.tasks; //$filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]});
            } else {
                var my_tasks = $filter('filter')($scope.tasks, { 'lot': $scope.selectedLot.name });
            }
        };

        $scope.getResults = function () {
            $scope.get_results = true;
            if (decodeURI($stateParams.activeTab) === 'Inventory') {
                $scope.onSelect(decodeURI($stateParams.activeTab));
                $scope.selectedIndex = 3;
            }
            $scope.submit();

            $scope.guiTaskStatus = $scope.selectedTaskStatus.name;
            $scope.guiSupplier = $scope.selectedSupplier.name;// ? $scope.selectedSupplier.name : 'All';
            $scope.guiCategory = $scope.selectedCategory.name;// ? $scope.selectedSupplier.name : 'All';
            $scope.guiEmployee = $scope.selectedEmployee.name ? $scope.selectedEmployee.name : 'All';
            $scope.guiStart = $scope.startDate;
            $scope.guiEnd = $scope.endDate;
            if ($scope.scheduledOn) {
                $scope.guiScheduledStart = $scope.scheduledStartDate;
                $scope.guiScheduledEnd = $scope.scheduledEndDate;
            } else {
                $scope.guiScheduledStart = '';
                $scope.guiScheduledEnd = '';
            }
            if ($scope.completedOn) {
                $scope.guiCompletedStart = $scope.completedStartDate;
                $scope.guiCompletedEnd = $scope.completedEndDate;
            } else {
                $scope.guiCompletedStart = '';
                $scope.guiCompletedEnd = '';
            }
            if (!$scope.materialDate) {
                $scope.guiScheduledStart = $scope.scheduledStartDate;
                $scope.guiScheduledEnd = $scope.scheduledEndDate;
            } else {
                $scope.guiScheduledStart = '';
                $scope.guiScheduledEnd = '';
            }
            $scope.guiBuilder = $scope.selectedBuilder.name;
            $scope.guiProject = $scope.selectedItem.name;
            $scope.guiPhase = $scope.selectedPhase.name;
            $scope.guiLot = $scope.selectedLot.name;
            $scope.guiTask = $scope.selectedTask.task_code;
        };

        $scope.changePayPeriod = function () {
            if (!$scope.selectedPayPeriod) return;

            $scope.startDate = new Date(this.selectedPayPeriod.start);
            $scope.endDate = new Date(this.selectedPayPeriod.end);

            $scope.startDate.setHours(0);
            $scope.startDate.setMinutes(0);
            $scope.startDate.setSeconds(0);
            $scope.endDate.setHours(23);
            $scope.endDate.setMinutes(59);
            $scope.endDate.setSeconds(59);
        };

        $scope.dateRangeUpdated = function () {
            $scope.startDate = new Date(this.reportDateRange.startDate);
            $scope.endDate = new Date(this.reportDateRange.endDate);

            $scope.startDate.setHours(0);
            $scope.startDate.setMinutes(0);
            $scope.startDate.setSeconds(0);
            $scope.endDate.setHours(23);
            $scope.endDate.setMinutes(59);
            $scope.endDate.setSeconds(59);
        };

        $scope.toggleScheduledDate = function (item) {
            $scope.scheduledOn = item.on;
        };

        $scope.toggleCompletedDate = function (item) {
            $scope.completedOn = item.on;
        };

        $scope.toggleMaterialDate = function (item) {
            $scope.materialDate = item.on;
        };
        $scope.toggleOnlyLeft = function (item) {
            $scope.showOnlyLeft = item.on;
        };

        $scope.dateScheduledUpdated = function () {
            $scope.scheduledStartDate = new Date($scope.reportDateScheduled.startDate);
            $scope.scheduledEndDate = new Date($scope.reportDateScheduled.endDate);

            $scope.scheduledStartDate.setHours(0);
            $scope.scheduledStartDate.setMinutes(0);
            $scope.scheduledStartDate.setSeconds(0);
            $scope.scheduledEndDate.setHours(23);
            $scope.scheduledEndDate.setMinutes(59);
            $scope.scheduledEndDate.setSeconds(59);

            if ($scope.scheduledOn)
                $scope.reportDateScheduled.on = true;
        };

        $scope.dateCompletedUpdated = function () {
            $scope.completedStartDate = new Date($scope.reportDateCompleted.startDate);
            $scope.completedEndDate = new Date($scope.reportDateCompleted.endDate);

            $scope.completedStartDate.setHours(0);
            $scope.completedStartDate.setMinutes(0);
            $scope.completedStartDate.setSeconds(0);
            $scope.completedEndDate.setHours(23);
            $scope.completedEndDate.setMinutes(59);
            $scope.completedEndDate.setSeconds(59);

            if ($scope.completedOn)
                $scope.reportDateCompleted.on = true;
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/databases.js